import axios from 'axios';

export default {
  async created() {
    await this.fetchCustomFieldVariable();
    this.dynamic_variables_sms_content_subject =
      this.dynamic_variables_sms_subject;
    if (!this.localModel.content) {
      this.localModel.content = '';
    }
    if (this.localModel.email_id) {
      this.emailTemplateId = this.localModel.email_id;
      this.templateType = 'user-email';
    }
    // await this.updatedEmailSender();
  },
  data() {
    return {
      showSubjectDropdown: false,
      emailSubjectVariableSearch: '',
      dynamic_variables_sms_content_subject: '',
      dynamic_variables_sms_subject: [
        {
          label: this.$t('frontend_groovemail_contacts_step2_first_name'),
          value: '{first_name}'
        },
        {
          label: this.$t('frontend_groovemail_contacts_step2_last_name'),
          value: '{last_name}'
        },
        {
          label: this.$t('frontend_groovemail_email_show_email'),
          value: '{email}'
        },
        {
          label: this.$t('frontend_groovemail_email_show_phone'),
          value: '{phone_number}'
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_company'),
          value: '{company}'
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_adress1'),
          value: '{address_1}'
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_adress2'),
          value: '{address_2}'
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_city'),
          value: '{city}'
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_state'),
          value: '{state}'
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_country'),
          value: '{country}'
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_zipcode'),
          value: '{zip}'
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_url'),
          value: '{url}'
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_taxnumber'),
          value: '{tax_number}'
        },
        {
          label: this.$t('frontend_groovemail_mail_lead_index_billing'),
          value: '{billing_address}'
        },
        {
          label: this.$t('frontend_groovemail_contacts_step2_ip_address'),
          value: '{ip_address}'
        }
      ]
    };
  },
  methods: {
    // Dynamic Variables
    copyVariableInSubject(option) {
      if (!this.localModel.timedelaydate) {
        this.localModel.timedelaydate= '';
      }
      this.localModel.timedelaydate += `${option.value}`;
      this.showSubjectDropdown = false;
      this.emailSubjectVariableSearch = '';
      this.dynamic_variables_sms_content_subject = this.dynamic_variables_sms_subject;
    },

    async fetchCustomFieldVariable() {
      try {
        const customFieldsData = await axios.post('/customfield-variables');
        customFieldsData.data.forEach(fieldData => {
          this.dynamic_variables_sms_subject.push(fieldData);
          const mergeTagData = fieldData;
          mergeTagData.name = mergeTagData.label;
          this.builderVariables.push(mergeTagData);
        });
      } catch (e) {
        console.log(e);
      }
    },

    closeSubjectVariables() {
      this.showSubjectDropdown = false;
    },

    openSubjectVariables() {
      this.showSubjectDropdown = true;
    },
    changedEmailSubjectSearchVariable(searchQuery) {
      if (searchQuery) {
        this.dynamic_variables_sms_content_subject =
          this.dynamic_variables_sms_subject.filter((ele) =>
            ele.label.toLowerCase().includes(searchQuery.toLowerCase())
          );
      } else {
        this.dynamic_variables_sms_content_subject =
          this.dynamic_variables_sms_subject;
      }
    },
  }
};
